import { Goals24 } from '../aurora/24px/studio/Goals24';
import { AnonymousUsers } from './AnonymousUsers';
import { Campaigns } from './Campaigns';
import { Catalogs } from './Catalogs';
import { ContactLookup } from './ContactLookup';
import { CreativeLibrary } from './CreativeLibrary';
import { Dashboard } from './Dashboard';
import { DataFeeds } from './DataFeeds';
import { Experiments } from './Experiments';
import { Integrations } from './Integrations';
import { IntelligentInsights } from './IntelligentInsights';
import { Journeys } from './Journeys';
import { Lists } from './Lists';
import { LogOut } from './LogOut';
import { Logs } from './Logs';
import { MessagingInsights } from './MessagingInsights';
import { OrgSettings } from './OrgSettings';
import { PredictiveGoals } from './PredictiveGoals';
import { Reports } from './Reports';
import { SavedInsights } from './SavedInsights';
import { Segmentation } from './Segmentation';
import { Snippets } from './Snippets';
import { Templates } from './Templates';

const Goals = () => <Goals24 isColorInherited />;

export enum HeaderNavIcons {
  ANONYMOUS_USERS = 'AnonymousUsers',
  CAMPAIGNS = 'Campaigns',
  CATALOGS = 'Catalogs',
  CONTACT_LOOKUP = 'ContactLookup',
  CREATIVE_LIBRARY = 'CreativeLibrary',
  DASHBOARD = 'Dashboard',
  DATA_FEEDS = 'DataFeeds',
  EXPERIMENTS = 'Experiments',
  INTEGRATIONS = 'Integrations',
  INTELLIGENT_INSIGHTS = 'IntelligentInsights',
  GOALS = 'Goals',
  JOURNEYS = 'Journeys',
  LISTS = 'Lists',
  LOG_OUT = 'LogOut',
  LOGS = 'Logs',
  MESSAGING_INSIGHTS = 'MessagingInsights',
  ORG_SETTINGS = 'OrgSettings',
  PREDICTIVE_GOALS = 'PredictiveGoals',
  REPORTS = 'Reports',
  SAVED_INSIGHTS = 'SavedInsights',
  SEGMENTATION = 'Segmentation',
  SNIPPETS = 'Snippets',
  TEMPLATES = 'Templates',
}

export const HEADER_NAV_ICONS = {
  [HeaderNavIcons.ANONYMOUS_USERS]: <AnonymousUsers />,
  [HeaderNavIcons.CAMPAIGNS]: <Campaigns />,
  [HeaderNavIcons.CATALOGS]: <Catalogs />,
  [HeaderNavIcons.CONTACT_LOOKUP]: <ContactLookup />,
  [HeaderNavIcons.CREATIVE_LIBRARY]: <CreativeLibrary />,
  [HeaderNavIcons.DASHBOARD]: <Dashboard />,
  [HeaderNavIcons.DATA_FEEDS]: <DataFeeds />,
  [HeaderNavIcons.INTELLIGENT_INSIGHTS]: <IntelligentInsights />,
  [HeaderNavIcons.GOALS]: <Goals />,
  [HeaderNavIcons.EXPERIMENTS]: <Experiments />,
  [HeaderNavIcons.INTEGRATIONS]: <Integrations />,
  [HeaderNavIcons.JOURNEYS]: <Journeys />,
  [HeaderNavIcons.LISTS]: <Lists />,
  [HeaderNavIcons.LOG_OUT]: <LogOut />,
  [HeaderNavIcons.LOGS]: <Logs />,
  [HeaderNavIcons.MESSAGING_INSIGHTS]: <MessagingInsights />,
  [HeaderNavIcons.ORG_SETTINGS]: <OrgSettings />,
  [HeaderNavIcons.REPORTS]: <Reports />,
  [HeaderNavIcons.PREDICTIVE_GOALS]: <PredictiveGoals />,
  [HeaderNavIcons.SAVED_INSIGHTS]: <SavedInsights />,
  [HeaderNavIcons.SEGMENTATION]: <Segmentation />,
  [HeaderNavIcons.SNIPPETS]: <Snippets />,
  [HeaderNavIcons.TEMPLATES]: <Templates />,
};
